import { render } from "./Planes.vue?vue&type=template&id=6b76dfba&scoped=true"
import script from "./Planes.vue?vue&type=script&lang=js"
export * from "./Planes.vue?vue&type=script&lang=js"

import "./Planes.vue?vue&type=style&index=0&id=6b76dfba&scoped=true&lang=css"

import exportComponent from "/Users/alexmeister/Documents/minigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b76dfba"]])

export default __exports__